<template v-scroll="onScroll">
	<div id="allmap" :style="mapStyle"></div>
</template>
<script>
	export default {
		data: function() {
			return {
				mapStyle: {
					width: '100%',
					height: this.mapHeight
				},
				mapImg:require("@/assets/img/home/klk.jpg"),
				company:"厦门酷联客电子科技有限公司",
				address:"厦门市湖里区园山南路806号联发电子市场B栋804号",
				tel:"(0592)8222272",
				desc:"厦门酷联客电子科技有限公司（简称“酷联客”）是一家物联网（IOT）开放式接入服务云平台的公司，面向产业提供联网服务，并以此为核心展开一系列增值服务运营。"
			}
		},
		props: {
			// 地图在该视图上的高度
			mapHeight: {
				type: String,
				default: "70vh"
			},
			// 经度
			longitude: {
				type: Number,
				default: 118.13752
			},
			// 纬度
			latitude: {
				type: Number,
				default: 24.511568
			},
			//精度
			precision:{
				type:Number,
				default:17
			}
		},
		mounted() {
			var map = new BMap.Map("allmap");
			map.centerAndZoom(new BMap.Point(this.longitude, this.latitude), this.precision);  // 初始化地图,设置中心点坐标和地图级别
			
			
			var top_left_control = new BMap.ScaleControl({anchor: BMAP_ANCHOR_TOP_LEFT});// 左上角，添加比例尺
			var top_left_navigation = new BMap.NavigationControl();  //左上角，添加默认缩放平移控件

			map.addControl(top_left_control);
			map.addControl(top_left_navigation);
			
			
			
			var content = '';
			content += '<div style="margin:0;line-height:20px;padding:2px;">';
			content += '	<img src="'+this.mapImg+'" alt="" style="float:right;zoom:1;overflow:hidden;width:140px;height:140px;margin-left:3px;"/>';
			content += '	地址：'+this.address+'<br/>';
			content += '	电话：'+this.tel+'<br/>';
			content += '	简介：'+this.desc;
			content += '</div>';
			var $this = this;
    		//创建检索信息窗口对象
    		var searchInfoWindow = null;
			searchInfoWindow = new BMapLib.SearchInfoWindow(map, content, {
				title  : $this.company,      //标题
				width  : 420,             //宽度
				height : 150,              //高度
				panel  : "panel",         //检索结果面板
				enableAutoPan : true,     //自动平移
				searchTypes   :[
					BMAPLIB_TAB_SEARCH,   //周边检索
					BMAPLIB_TAB_TO_HERE,  //到这里去
					BMAPLIB_TAB_FROM_HERE //从这里出发
				]
			});
	
		    var poi = new BMap.Point(this.longitude,this.latitude);
		    var marker = new BMap.Marker(poi); //创建marker对象
		    marker.enableDragging(); //marker可拖拽
		    map.addOverlay(marker); //在地图中添加marker
			searchInfoWindow.open(marker);	//打开信息窗口
			marker.addEventListener("click", function(e){
			    searchInfoWindow.open(marker);
		    })
		}
	}
</script>
<style lang="less">

</style>


// WEBPACK FOOTER //
// bmap.vue?111eb195